import {
  Heading,
  MaterialUICore,
  axiomTokens,
  Button as DSButton,
  Body as DSBody,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;

const { border, color, spacing } = axiomTokens;

const alignItemsStart = 'flex-start';

export const Card = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: alignItemsStart,
  rowGap: spacing[4],
  width: '100%',
});

export const Divider = styled('hr')({
  margin: 0,
  width: '100%',
  borderStyle: 'solid',
  borderWidth: border.width.xs,
  borderColor: color.others.divider,
});

export const PriceContainer = styled(Heading)({
  whiteSpace: 'nowrap',
});

export const DescriptionTitle = styled(Heading)({
  color: color.typeface.feedback.info,
});

export const ProductSelectedWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',

  [theme.breakpoints.down('sm')]: {
    alignItems: 'baseline',
  },
}));

export const VoucherWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',

  [theme.breakpoints.down('sm')]: {
    gap: spacing[4],
  },
}));

export const TotalWrapper = styled(ProductSelectedWrapper)({
  padding: spacing[2],
});

export const TotalAmount = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
});

export const WarningRemoveVoucher = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: alignItemsStart,
  textAlign: 'left',
  backgroundColor: color.surface.feedback.warning.subtle,
  padding: spacing[2],
  borderColor: color.border.feedback.warning,
  borderStyle: 'solid',
  border: border.width.xs,
  borderRadius: border.radius.sm,
  width: '100%',
});

export const WarningContent = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: spacing[2],
  alignItems: 'center',
});

export const WarningButton = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'row',
  gap: spacing[3],
  marginTop: spacing[2],
  width: '100%',
  alignItems: alignItemsStart,
  paddingRight: spacing[3],
});

export const Button = styled(DSButton)({
  color: color.typeface.smooth,
});

export const Body = styled(DSBody)({
  color: color.typeface.feedback.warning,
});
